import { ProfileView } from "@components";

export const Profile = () => {
    return (
        <div>
            <ProfileView />
        </div>
    );
};
